/**
 * Check if a paper portfolio meets graduation criteria.
 * Uses inception-to-date metrics as a proxy until the API
 * adds a windowed graduation_ready field.
 *
 * Thresholds: realized PnL >= +15%, >= 10 closed trades, win rate >= 60%.
 */
export function isGraduationReady(detail) {
  if (!detail) return false;
  const pnlPct = parseFloat(detail.realized_pnl_pct || 0);
  const closedCount = detail.closed_positions?.length || 0;
  const winRate = parseFloat(detail.win_rate || 0);
  return pnlPct >= 15 && closedCount >= 10 && winRate >= 60;
}
